import * as React from "react";
import IHomework from "../../typings/IHomework";
import { Icon } from "../../components";
import * as styles from "./styles.scss";
import { themeVariables } from "../../entryes/panel/MUI";

interface IProps {
  homework: IHomework;
}

export default class PrivateToggler extends React.Component<
  IProps,
  {
    isPrivate: boolean;
  }
> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isPrivate: props.homework.isPrivate,
    };
  }

  togglePrivate() {
    const body = new FormData();
    body.append("id", this.props.homework.id.toString());
    body.append("lesson_id", this.props.homework.lesson.id.toString());
    body.append("course_id", document.body.dataset["courseId"] || "0");
    body.append("data[is_private]", !this.state.isPrivate ? "yes" : "no");

    fetch(this.props.homework.visibleUrl, {
      method: "POST",
      credentials: "include",
      headers: new Headers({
        "X-Requested-With": "XMLHttpRequest",
      }),
      body,
    });

    this.setState({
      isPrivate: !this.state.isPrivate,
    });
  }

  render() {
    return (
      <div className={styles.visibleIcon}>
        <Icon
          name={this.state.isPrivate ? "eyeOff" : "eye"}
          size={21}
          color={themeVariables.palette.primary.main}
          onClick={this.togglePrivate.bind(this)}
          tooltip={
            this.state.isPrivate
              ? "Этот отчет не виден другим ученикам курса. Нажмите, чтобы скрыть его"
              : "Этот отчет виден другим ученикам курса. Нажмите, чтобы скрыть его"
          }
        />
      </div>
    );
  }
}
